import styled from 'styled-components';
import { useThemeContext } from '@/shared/theme';
import LogoWhite from '@assets/full-logo-white.svg?react';

export const HeaderLogo = () => {
  const { theme } = useThemeContext();

  {
    return theme === 'light' ? (
      <img
        alt="wordmark.svg"
        src="https://suresteps-public.s3.amazonaws.com/wordmark.svg"
        style={{ height: 25 }}
      />
    ) : (
      <LogoWrapper>
        <LogoWhite />
      </LogoWrapper>
    );
  }
};

const LogoWrapper = styled.div`
  display: flex;
  svg {
    height: 25px;
    width: auto;
  }
`;
